export default [
  {
    label: "Node",
    name: "node",
    type: "text",
    required: true,
  },
  {
    label: "Tech ID",
    name: "techId",
    type: "text",
    required: true,
  },
  {
    label: "Name",
    name: "name",
    type: "text",
    required: true,
  },
  {
    label: "Full Name",
    name: "fullname",
    type: "text",
  },
  {
    label: "Nickname",
    name: "nickname",
    type: "text",
    required: true,
  },
  {
    label: "Team",
    name: "team",
    type: "select",
    options: [
      "BDT",
      "RHG-A",
      "RHG-B",
      "SCORE",
      "TEAM A",
      "TEAM B",
      "TEAM C",
      "TU",
    ],
    required: true,
  },
  {
    label: "Email",
    name: "email",
    type: "text",
  },
  {
    label: "Tel",
    name: "tel",
    type: "text",
  },
  {
    label: "Token",
    name: "accessToken",
    type: "text",
  },
  {
    label: "Role",
    name: "roles",
    type: "checkbox",
    options: [{ role: "Record" }, { role: "Score" }],
  },
  {
    label: "Certificate",
    name: "certificate",
    type: "select",
    options: ["Trainee", "Basic", "Advance"],
  },
  {
    label: "Status",
    name: "status",
    type: "select",
    options: ["Available", "Unavailable"],
  },
  {
    label: "Employment Type",
    name: "employmentType",
    type: "select",
    options: ["Full Time", "Part Time"],
  },

  {
    label: "Guarantee Case",
    name: "guaranteeCase",
    type: "text",
  },

  {
    label: "Split Night Topup (THB)",
    name: "splitNightTopupRate",
    type: "text",
  },
  { type: "section", label: "Home Study" },

  {
    label: "Home 1st Case (THB)",
    name: "homeFirstCaseRate",
    type: "text",
  },

  {
    label: "Home 2nd Case (THB)",
    name: "homeSecondCaseRate",
    type: "text",
  },
  { type: "section", label: "Overnight Pulse Study" },

  {
    label: "Overnight Pulse 1st Case (THB)",
    name: "overnightFirstCaseRate",
    type: "text",
  },

  {
    label: "Overnight Pulse 2nd Case (THB)",
    name: "overnightSecondCaseRate",
    type: "text",
  },
  { type: "section", label: "RPH Full Night Study" },

  {
    label: "RPH Full Night 1st Case (THB)",
    name: "RPHFullnightFirstCaseRate",
    type: "text",
  },

  {
    label: "RPH Full Night 2nd Case (THB)",
    name: "RPHFullnightSecondCaseRate",
    type: "text",
  },
  { type: "section", label: "RPH Split Night Study" },

  {
    label: "RPH Split Night 1st Case (THB)",
    name: "RPHSplitNightFirstCaseRate",
    type: "text",
  },

  {
    label: "RPH Split Night 2nd Case (THB)",
    name: "RPHSplitNightSecondCaseRate",
    type: "text",
  },

  // ---- RATES: Section 1
  { type: "section", label: "Record" },
  { label: "Cash (THB)", name: "recordCashRate", type: "text" },
  {
    label: "Social Security (THB)",
    name: "recordSocialSecurityRate",
    type: "text",
  },

  // ---- RATES: Section 2
  { type: "section", label: "Score" },
  {
    label: "Cash (THB)",
    name: "scoreCashRate",
    type: "text",
  },
  {
    label: "Social Security (THB)",
    name: "scoreSocialSecurityRate",
    type: "text",
  },

  /////////////////////////////////////

  {
    label: "Note",
    name: "note",
    type: "textarea",
    // options: ["Available", "Unavailable"],
  },
];
